import { render, staticRenderFns } from "./gl-disclaimer.vue?vue&type=template&id=2452df99"
import script from "./gl-disclaimer.vue?vue&type=script&lang=js"
export * from "./gl-disclaimer.vue?vue&type=script&lang=js"
import style0 from "./gl-disclaimer.vue?vue&type=style&index=0&id=2452df99&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports